import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistorySection from '../../../../components/HistorySection';

import { formatPartialDate } from 'Utility/date';
import { getPatientAgeInMonthsWithOneDecimal } from '../../../../utility/patientInfo';
import { nsaaScore, showPatientAgeInMonthsOnForm } from '../../utils';
import InfoPopover from '../../../../components/InfoPopover';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import { Item } from '../../../../components/Grid';
import DocumentCreationButton from '../../../../components/DocumentCreationButton';

const NSAA = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'motor.nsaa'} />}
      newButton={
        <DocumentCreationButton
          name="nsaa"
          text={'motor.newNSAA'}
          onClick={startEdit({}, 'nsaa')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={6}>
              <FormattedMessage id={'motor.nsaaScore'} />
            </Item>
          </>
        }
        contentFormat={(d: INSAA): React.JSX.Element => (
          <>
            <Item xs={2}>
              {showPatientAgeInMonthsOnForm(d.date) ? (
                <FormattedMessage
                  id="motor.dateAndMonth"
                  values={{
                    date: formatPartialDate(d.date),
                    months: getPatientAgeInMonthsWithOneDecimal(d.date),
                  }}
                />
              ) : (
                formatPartialDate(d.date)
              )}
            </Item>
            <Item xs={6}>
              {nsaaScore(d) === 'notCounted' ? <InfoPopover text="general.notFilled" color="primary" /> : nsaaScore(d)}
            </Item>
          </>
        )}
        makeControls
        historyRowControls={(d: IControlProps) => (
          <div id={'nsaaHistoryControl'}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </div>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: INSAA[];
  startEdit: (document: TAnyObject, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
  view?: IView;
}

export default NSAA;
